/**
 * PreferencesReducer
 */
import { ActionReducer, IAction } from '..';
import { PreferencesFormData } from '@app/shared/types/preferences/preferences.type';
import { PreferencesActions } from '@app/store/actions/preferences/preferences.actions';
import { COMPANY_PREFERENCES_DEFAULTS } from '@config/company-preferences-defaults';
import { isEqual, merge } from 'lodash';
import { XVIError } from '@shared/models';

/**
 * PreferencesState interface
 */
export interface PreferencesState {
  company: PreferencesFormData;
  site: PreferencesFormData;
  companyId: string;
  siteId: string;
  formData: PreferencesFormData;
  sitePathDiff: string[];
  errors: XVIError;
  loader: boolean;
  showSelectedSitesModal: boolean;
  operationResult: any;
  schema: any;
  selectedSites: string[];
  lastSelectedSites: string[];
}

export const INITIAL_STATE_PREFERENCES: PreferencesState = {
  company: COMPANY_PREFERENCES_DEFAULTS,
  companyId: null,
  siteId: null,
  site: null,
  formData: null,
  sitePathDiff: [],
  errors: null,
  loader: false,
  showSelectedSitesModal: false,
  operationResult: null,
  schema: null,
  selectedSites: [],
  lastSelectedSites: [],
};

/**
 * This function updates preferences state
 *
 */
export const preferencesReducer: ActionReducer<PreferencesState> = (
  state: PreferencesState = INITIAL_STATE_PREFERENCES,
  action: IAction,
): PreferencesState => {
  const { payload } = action;
  if (
    isEqual(
      PreferencesActions.FETCH_PREFERENCES_FOR_COMPANY_SUCCESS,
      action.type,
    )
  ) {
    const newState: PreferencesState = merge({}, INITIAL_STATE_PREFERENCES, {
      company: payload.response.preferences,
      companyId: payload.response.company_id,
      documentId: payload.response._id,
      formData: payload.response.preferences,
      operationResult: payload,
      site: INITIAL_STATE_PREFERENCES.site,
      siteId: INITIAL_STATE_PREFERENCES.siteId,
    });

    return newState;
  }

  return state;
};
